import React from 'react';
import { StarIcon } from 'lucide-react';
import { Section } from './Shared';
export type TestimonialProps = {
  initials: string;
  name: string;
  location: string;
  context?: string;
  text: string;
  accent?: 'sage' | 'rose' | 'gold';
};
const accents: Record<NonNullable<TestimonialProps['accent']>, string> = {
  sage: 'bg-brand-sageMid',
  rose: 'bg-brand-rose',
  gold: 'bg-brand-gold'
};
export function TestimonialCard({
  initials,
  name,
  location,
  context,
  text,
  accent = 'sage'
}: TestimonialProps) {
  return <article className="paper-panel flex h-full flex-col rounded-2xl border-l-4 border-l-brand-gold p-6 md:p-8" data-id="element-299" data-mp="31z37gf6t2x34">
      <div className="mb-4 flex items-center" data-id="element-300" data-mp="2x11r420rlbvc">
        <div className={`mr-4 flex h-12 w-12 shrink-0 items-center justify-center rounded-full text-sm font-bold text-brand-cream ring-1 ring-brand-gold/40 md:text-lg ${accents[accent]}`} data-id="element-301" data-mp="2s28d88hkfiun">
          {initials}
        </div>
        <div data-id="element-302" data-mp="qbeq9058zzcm">
          <div className="mb-1 flex text-brand-gold" data-id="element-303" data-mp="qav8pkjifcz4">
            {Array.from({
            length: 5
          }, (_, index) => <StarIcon key={index} className="h-4 w-4 fill-current" data-id="element-304" data-mp="h816vm00ecjf" />)}
          </div>
          <p className="font-semibold text-brand-taupe md:text-lg" data-id="element-305" data-mp="m6ch3xu7up26">{name}</p>
          <p className="text-xs text-brand-muted md:text-sm" data-id="element-306" data-mp="78trkt9ps7to">
            {location}
            {context ? ` — ${context}` : ''}
          </p>
        </div>
      </div>
      <p className="flex-grow font-display text-sm italic leading-relaxed text-brand-textLight md:text-base" data-id="element-307" data-mp="zwpqm4mrabtm">
        “{text}”
      </p>
    </article>;
}
const testimonials: TestimonialProps[] = [{
  initials: 'MG',
  name: 'Martina G.',
  location: 'CABA',
  context: 'Emprendedora de Cosmética Natural',
  accent: 'sage',
  text: 'Hace 3 meses vendo cremas sin estrategia. Con este pack aprendí a calcular mis costos reales, a diseñar etiquetas que venden y, lo más importante, a cobrar premium sin culpa. Este mes llegué a $40.000 ARS. Antes ganaba $8.000.'
}, {
  initials: 'LM',
  name: 'Lucía M.',
  location: 'Mendoza',
  context: 'Skincare Consciente',
  accent: 'rose',
  text: 'La parte de alquimia vibracional y programación lunar cambió mi forma de trabajar. Mis clientes notan la diferencia desde el primer uso. Además, el branding magnético hizo que mis redes crecieran 300% en 2 meses.'
}, {
  initials: 'DR',
  name: 'Daniela R.',
  location: 'Rosario',
  context: 'Recién emprendedora',
  accent: 'gold',
  text: 'Recién empezaba y no sabía por dónde arrancar. Este pack me dio toda la estructura desde el primer día: desde qué insumos comprar hasta cómo cerrar la venta por WhatsApp. Ahora trabajo con criterio y mis productos se venden solos.'
}];
export function InitialTestimonials() {
  return <Section className="pb-14 pt-6" data-id="element-308" data-mp="10s9rn7pdm2r9">
      <div className="mx-auto max-w-3xl" data-id="element-309" data-mp="10tb33dab0r9i">
        <TestimonialCard {...testimonials[0]} data-id="element-310" data-mp="vsdqdg82cpfe" />
      </div>
    </Section>;
}
export function MoreTestimonials() {
  return <Section className="pb-16 pt-8" data-id="element-311" data-mp="qtaizp4m2749">
      <div className="mb-10 text-center" data-id="element-312" data-mp="qu2d0vik7wsf">
        <h2 className="font-serif text-2xl font-bold text-brand-taupe md:text-4xl" data-id="element-313" data-mp="32h5x8bqo6zmc">
          ❤️ LO QUE DICEN LAS EMPRENDEDORAS QUE YA LO TIENEN
        </h2>
      </div>
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-6 md:grid-cols-3" data-id="element-314" data-mp="37i3feobojtnu">
        {testimonials.map(testimonial => <TestimonialCard key={testimonial.initials} {...testimonial} data-id="element-315" data-mp="3cd8vv7mbcg4j" />)}
      </div>
    </Section>;
}